import Vue from 'vue'
import VueRouter from 'vue-router'
import pages from './pages'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [...pages]
})


// router.beforeEach((to,from,next)=>{
//   const token = localStorage.getItem('token')
//   if(to.path=='/' && token){
//     next('/')
//   }else{
//     next('/login')
//   }
// })
export default router
